<script>
export default {
  translate25Context: "question24",
  components: {},
  props: {
    component: Object,
    handler: Object,
  },
  computed: {
    sortedTags() {
      return Object.values(this.component.tags).sort(this.sortQ);
    },
  },
  data() {
    return {
      pending: false,
      showAddTagModal: false,
      errorMessage: undefined,
      tag: "",
      tagToBeDeleted: undefined,
    };
  },
  methods: {
    sortQ(a, b) {
      return a.created - b.created;
    },
    async saveTag() {
      try {
        this.pending = true;
        await this.handler.action(this.component["#id"], "add", [this.tag]);
        this.showAddTagModal = false;
      } catch (e) {}
      this.pending = false;
      this.tag = "";
    },
    async deleteTag() {
      this.pending = true;
      await this.handler.action(this.tagToBeDeleted["#id"], "delete");
      this.pending = false;
      this.tagToBeDeleted = undefined;
    },
  },
};
</script>

<template>
  <div class="question24-tag-editor">
    <f-modal-base
      v-if="tagToBeDeleted"
      :title2="$vt('Delete Tag')"
      :pending="pending"
      closable
      @close="tagToBeDeleted = undefined"
      class="question-tag-modal"
    >
      <template #content>
        <f-hint type="negative">
          <template #message>
            {{ $vt("Are you sure to delete '{0}' tag? This action cannot be undone.", [tagToBeDeleted.title]) }}
          </template>
        </f-hint>
      </template>
      <template #actions>
        <f-button type="tertiary" @click.stop="tagToBeDeleted = undefined"
          >{{ $vt('No') }}</f-button
        >
        <f-button :pending="pending" type="negative" @click="deleteTag()"
          >{{ $vt('Yes') }}</f-button
        >
      </template>
    </f-modal-base>

    <f-modal-base
      v-if="showAddTagModal"
      :title2="$vt('Add Tag')"
      :pending="pending"
      closable
      @close="showAddTagModal = false"
      class="question-tag-modal"
    >
      <template #content>
        <f-textfield :input.sync="tag">
          <template #label> {{ $vt('Tag') }} </template>
        </f-textfield>
      </template>
      <template #actions>
        <f-button type="tertiary" @click.stop="showAddTagModal = false"
          >{{ $vt('Cancel') }}</f-button
        >
        <f-button type="primary" @click="saveTag()">{{ $vt('Save') }}</f-button>
      </template>
    </f-modal-base>

    <f-list>
      <template #title>
        {{ component.title }}
      </template>
      <template #actions
        ><f-button type="icon tertiary" @click="showAddTagModal = true">
          <f-icon icon="fa6-plus"></f-icon> </f-button
      ></template>
      <template #items>
        <div
          class="question24-tag-editor-tags-tag"
          v-for="tag in sortedTags"
          :key="tag['#id']"
        >
          <div class="question24-tag-editor-tags-tag-title">
            {{ tag.title }}
          </div>
          <f-icon
            v-if="!tag.undeletable"
            @click="tagToBeDeleted = tag"
            icon="fa6-circle-xmark"
          ></f-icon>
        </div>
      </template>
    </f-list>
  </div>
</template>

<style lang="scss">
.question24-tag-editor {
  .f-list {
    .f-list-items {
      padding: 4px;
      height: 100px;
      .f-sexy-scroll {
        display: flex;
        flex-direction: column;
        gap: 6px;
        .question24-tag-editor-tags-tag {
          display: flex;
          padding: 4px;
          margin: 4px 0;
          align-items: center;
          height: auto;
          &:hover {
          }
          .question24-tag-editor-tags-tag-title {
            color: var(--white-a50);
            font-family: Lato;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }

          .f-icon {
            cursor: pointer;
            font-size: 20px;
            color: var(--white-a25);
            margin-left: auto;
            &:hover {
              color: var(--white-a50);
            }
            &:active {
              color: var(--white-a75);
            }
          }
        }
      }
    }
  }
}
</style>